export const normalizePhoneNumber = (phone: string): string => {
  return phone.replace(/[\s\-()]/g, '')
}

export const isValidPhoneNumber = (phone: string): boolean => {
  // Only accept Swedish international format: +46 followed by 9-10 digits
  // Examples: +46701234567, +46812345678
  const phonePattern = /^\+46\d{9,10}$/
  return phonePattern.test(phone)
}
